import { useMutation, useQuery } from "react-query";
import reviewApi from "../apis/review";
const {
  fetchAllBatchesForReview,
  getAllSkusForReview,
  getSkusForReview,
  acceptSkuOnReview,
  acceptFileOnReview,
  rejectFileOnReview,
  saveMarkingsOnFile,
  deleteMarkingOnFile,
  downloadDeliverable,
} = reviewApi;
export const useGetAllBatchesForReview = (
  remark,
  pageNum,
  pageSize,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, pageNum, pageSize],
    () => fetchAllBatchesForReview(pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );
export const useGetAllSkusForReview = (
  remark,
  batchId,
  reviewStatus,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, batchId, reviewStatus],
    () => getAllSkusForReview(batchId, reviewStatus),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useGetSkuForReview = (
  remark,
  batchId,
  skuId,
  onSuccess,
  onError
) =>
  useQuery(
    ["" + remark, batchId, skuId],
    () => getSkusForReview(batchId, skuId),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );

export const useAcceptSkuOnReview = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return acceptSkuOnReview(payload);
    },
    onSuccess,
    onError,
  });
};

export const useAcceptFileOnReview = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return acceptFileOnReview(payload);
    },
    onSuccess,
    onError,
  });
};
export const useRejectSkuOnReview = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return rejectFileOnReview(payload);
    },
    onSuccess,
    onError,
  });
};
export const useSaveMarkingsOnFile = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return saveMarkingsOnFile(payload);
    },
    onSuccess,
    onError,
  });
};

export const useDeleteMarkingsOnFile = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return deleteMarkingOnFile(payload);
    },
    onSuccess,
    onError,
  });
};
export const useDownloadDeliverable = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return downloadDeliverable(payload);
    },
    onSuccess,
    onError,
  });
};
